/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    AggregatedCellarDto,
    PageBottleDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class CellarControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        getDepartmentAggregatedCellar(
                    orgUnitId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<AggregatedCellarDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/cellar/department/${orgUnitId}/aggregated`;

            return this._httpClient.get<AggregatedCellarDto>(url, requestOptions);
    }


        getDepartmentDetailedCellar(
                    orgUnitId: number
                , 
                queryParams: {
                    wineProductInstanceId?: number,
                    wineProductId?: number,
                    userLegalEntityId?: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageBottleDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/cellar/department/${orgUnitId}/detailed`;

            return this._httpClient.get<PageBottleDto>(url, requestOptions);
    }


        getPersonalAggregatedCellar(
                    userId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<AggregatedCellarDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/cellar/user/${userId}/aggregated`;

            return this._httpClient.get<AggregatedCellarDto>(url, requestOptions);
    }


        getPersonalDetailedCellar(
                    userId: number
                , 
                queryParams: {
                    wineProductInstanceId?: number,
                    wineProductId?: number,
                    userLegalEntityId?: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageBottleDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/cellar/user/${userId}/detailed`;

            return this._httpClient.get<PageBottleDto>(url, requestOptions);
    }


}

